import {Component, OnInit, QueryList, ViewChildren} from '@angular/core';
import {WidgetDirective} from '@components/widget/widget.directive';
import {Tab} from '@models/tab';
import {Favorite} from '@models/favorite';
import {EMPTY_FAVORITE, EMPTY_USER} from '@models/empty';
import {User} from '@models/user';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {AdService} from '@services/ad.service';
import {AuthenticationService} from '@services/authentification.service';
import {Title} from '@angular/platform-browser';
import {ConfirmComponent} from '@components/popup/confirm/confirm.component';
import {AddComponent} from '@module/favorites/popup/add/add.component';
import {ShareComponent} from '@components/popup/share/share.component';
import {TrackingService} from '@services/tracking.service';
import {DuplicateComponent} from '@module/favorites/popup/duplicate/duplicate.component';
import * as $ from 'jquery';
import {OnboardingService} from '@services/onboarding.service';
import {AlertService} from '@services/alert.service';
import {UpgradePlanV2Component} from '@components/popup/upgrade-plan-v2/upgrade-plan-v2.component';
import {UserService} from '@services/user.service';
import {LoginFormComponent} from '@components/popup/login-form/login-form.component';
import {RenameComponent} from '@module/favorites/popup/rename/rename.component';
import {TutoComponent} from '@components/popup/tuto/tuto.component';

@Component({
    selector: 'app-detail-wrap',
    templateUrl: './detail-wrap.component.html',
    styleUrls: ['./detail-wrap.component.scss']
})
export class DetailWrapComponent implements OnInit {

    @ViewChildren(WidgetDirective) widgets: QueryList<WidgetDirective>;

    tabs: Tab[] = [];
    favorite: Favorite = Object.assign({}, EMPTY_FAVORITE);
    params;
    user: User = Object.assign({}, EMPTY_USER);
    link = window.location.toString();
    tuto = '';

    constructor(
        public dialog: MatDialog,
        private route: ActivatedRoute,
        private adService: AdService,
        private onboardingService: OnboardingService,
        private router: Router,
        private alertService: AlertService,
        public authenticationService: AuthenticationService,
        private titleService: Title,
        public userService: UserService,
        public trackingService: TrackingService,
    ) {
    }

    ngOnInit() {
        this.findTuto();
        this.router.events.subscribe((val) => {
            if (val instanceof NavigationEnd) {
                this.link = val.urlAfterRedirects.toString();
                this.findTuto();
            }
        });

        this.route.data.subscribe(data => {
            this.tabs = [];
            data.tabs.forEach(tab => {
                this.tabs.push(Object.assign({}, tab));
            });
        });

        if (!this.authenticationService.isAllowed('basique')) {
            this.trackingService.click('favorite_detail_plan', '');
            if (!this.authenticationService.isLogin) {
                const dialogRef = this.dialog.open(LoginFormComponent, {
                    width: '550px',
                    data: {
                        disableClose: false
                    },
                });
            } else {
                const dialogRef = this.dialog.open(UpgradePlanV2Component, {
                    width: '520px',
                    disableClose: true,
                    data: {visuel: 'assets/upgrade/simulation.png', plan: 'Basique', feature: 'Simulateur d\'investissement', disableClose: true},
                });
            }
        }

        this.route.params.subscribe(params => {
            this.params = params;

            this.adService.getFavorite(params.favoriteId).subscribe(result => {
                if (result.title == 'redirect') {
                    this.router.navigate(['/app/annonces/share', result.public_id]);
                    return;
                }

                this.favorite = this.adService.updateValues(result);

                this.titleService.setTitle('LyBox -  ' + this.favorite.favorite_list.title + ' - ' + this.favorite.title);
                this.adService.cacheFavorite(this.favorite);
                if (this.authenticationService.currentUser.user_onboarding.auto && this.authenticationService.currentUser.user_onboarding.pdf.status == 'not_started') {
                    this.onboardingService.startPDF(params.id, params.favoriteId).subscribe();
                }
            }, error => {
                if (error != 'token_outdate') {
                    this.alertService.error('Favoris introuvable');
                    this.router.navigate(['/app/favorites', params.id]);
                }
            });
        });

        this.user = this.authenticationService.currentUser;
    }

    findTuto() {
        if (this.link.includes('/annonce')) {
            this.tuto = 'annonce';
        } else if (this.link.includes('/ville')) {
            this.tuto = 'ville';
        } else if (this.link.includes('/inout')) {
            this.tuto = 'rendement';
        } else if (this.link.includes('/impot')) {
            this.tuto = 'impot';
        } else {
            this.tuto = '';
        }
    }

    deleteFavorite(): void {
        const dialogRef = this.dialog.open(ConfirmComponent, {
            width: '480px',
            data: {message: 'Etes-vous sûr de vouloir supprimer ce favoris et perdre toute les informations saisies ?'},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === true) {
                this.trackingService.deleteFavorite();
                this.adService.deleteFavorite(this.favorite).subscribe(r => {
                    this.router.navigate(['/app/favorites', this.favorite.favorite_list.id]);
                });
            }
        });
    }

    moveFavorite(): void {
        const dialogRef = this.dialog.open(AddComponent, {
            width: '480px',
            data: {favorite: this.favorite, mode: 'move'},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== false && result !== undefined) {
                this.router.navigate(['/app/favorites', result[0], this.favorite.id]);
            }
        });
    }

    renameFavorite(): void {
        const dialogRef = this.dialog.open(RenameComponent, {
            width: '480px',
            data: {favorite: this.favorite},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== false && result !== undefined) {
                this.favorite = result;
                this.adService.updateCacheFavorite(this.favorite);
            }
        });
    }

    dupplicateFavorite(): void {
        const dialogRef = this.dialog.open(DuplicateComponent, {
            width: '480px',
            data: {favorite: this.favorite},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== false && result !== undefined) {
                this.router.navigate(['/app/favorites', this.favorite.favorite_list.id, result.id]);
            }
        });
    }

    share(): void {
        const dialogRef = this.dialog.open(ShareComponent, {
            width: '480px',
            data: {favorite: this.favorite},
        });

        dialogRef.afterClosed().subscribe(result => {
        });
    }

    upgradePlan() {
        if (!this.authenticationService.isLogin) {
            const dialogRef = this.dialog.open(LoginFormComponent, {
                width: '550px',
                data: {
                    disableClose: false
                },
            });
        } else {
            const dialogRef = this.dialog.open(UpgradePlanV2Component, {
                width: '520px',
                data: {visuel: 'assets/upgrade/dashboard.png', plan: 'Expert', feature: 'Dashboard personnalisé'}
            });
        }
    }

    compareAdd() {
        if (!this.authenticationService.isAllowed('essentiel')) {
            if (!this.authenticationService.isLogin) {
                const dialogRef = this.dialog.open(LoginFormComponent, {
                    width: '550px',
                    data: {
                        disableClose: false
                    },
                });
            } else {
                const dialogRef = this.dialog.open(UpgradePlanV2Component, {
                    width: '520px',
                    data: {visuel: 'assets/upgrade/compare.png', plan: 'Essentiel', feature: 'Comparaison entre projets'}
                });
            }
        } else {
            this.adService.getCompareAd().subscribe(ads => {
                if (ads.length >= 5) {
                    this.alertService.error('Comparaison limité à 5 projets, veuillez supprimer un projet dans la comparaison.');
                } else {
                    this.adService.addCompareAd(this.favorite.id);
                    this.router.navigate(['/app/favorites/compare']);
                }
            });
        }
    }

    openTuto() {
        const dialogRef = this.dialog.open(TutoComponent, {
            width: '1000px',
            maxWidth: '100%',
            data: {video: this.tuto}
        });
    }
}
